import { Grid2 as Grid } from "@mui/material"
import Button from "@mui/material/Button"
import { Field, Formik } from "formik"
import { useMemo } from "react"
import * as yup from "yup"
import { Donatore } from "../../types"
import { transformErrorForForm } from "../../utils/utils"
import { FormInDialogProps } from "../DialogForm"
import { FormikTextField, FormikDatePicker } from "./formsHelpers"
import { useTranslation } from "react-i18next"
import { ACLuogo } from "./autocompletes"
import LuogoForm from "./LuogoForm"
import { useLuogoCreate } from "../../hooks/luoghi"
import useUserCanWriteAndDelete from "../../hooks/permissions"


export default function DonatoreForm({ item, save, ref }: FormInDialogProps<Donatore>) {
  const { t } = useTranslation()
  const userCanWriteAndDelete = useUserCanWriteAndDelete()
  const initialValues = useMemo(() => {
    return (
      item ?? {
        nome: "",
        indirizzo: "",
        telefono: "",
        email: "",
        data_nascita: undefined,
        luogo_nascita: undefined,
        mobile: "",
        doc_id: "",
        cf: "",
        note: "",
      }
    )
  }, [item])

  const schema = useMemo(
    () =>
      yup.object().shape({
        nome: yup.string().required().label(t("donatore.nome")),
        email: yup.string().email().label(t("donatore.email")),
      }),
    [t]
  )

  const { mutateAsync: createLuogo } = useLuogoCreate()

  return (
    <Formik
      validationSchema={schema}
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values, formikBag) => {
        return save(values as Donatore).catch((e) => {
          const localError = transformErrorForForm(e)
          formikBag.setErrors(localError)
        })
      }}
    >
      {({ handleSubmit, values, setFieldValue }) => {
        return (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={1} sx={{ py: 2 }}>
              <Grid size={4}>
                <Field
                  component={FormikTextField}
                  name="cognome"
                  label={t("donatore.cognome")}
                  required
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  slotProps={{
                    input: {
                      readOnly: userCanWriteAndDelete ? false : true,
                    },
                  }}
                />
              </Grid>
              <Grid size={4}>
                <Field
                  component={FormikTextField}
                  name="nome"
                  label={t("donatore.nome")}
                  required
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  slotProps={{
                    input: {
                      readOnly: userCanWriteAndDelete ? false : true,
                    },
                  }}
                />
              </Grid>
              <Grid size={4}></Grid>
              <Grid size={4}>
                <Field
                  component={FormikDatePicker}
                  name="data_nascita"
                  label={t("donatore.data_nascita")}
                  required
                  margin="dense"
                  type="date"
                  fullWidth
                  variant="outlined"
                  readOnly={!userCanWriteAndDelete}
                />
              </Grid>
              <Grid size={4}>
                <ACLuogo
                  margin="dense"
                  variant="outlined"
                  label={t("donatore.luogo_nascita")}
                  value={values.luogo_nascita}
                  onChange={(value) => {
                    setFieldValue("luogo_nascita", value)
                  }}
                  FormComponent={LuogoForm}
                  create={createLuogo}
                  initialCreate={(search) => ({ nome: search })}
                 
                />
              </Grid>

              <Grid size={4}></Grid>
              <Grid size={4}>
                <Field
                  component={FormikTextField}
                  name="indirizzo"
                  label={t("donatore.indirizzo")}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  slotProps={{
                    input: {
                      readOnly: userCanWriteAndDelete ? false : true,
                    },
                  }}
                />
              </Grid>
              <Grid size={4}>
                <Field
                  component={FormikTextField}
                  name="telefono"
                  label={t("donatore.telefono")}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  slotProps={{
                    input: {
                      readOnly: userCanWriteAndDelete ? false : true,
                    },
                  }}
                />
              </Grid>
              <Grid size={4}>
                <Field
                  component={FormikTextField}
                  name="mobile"
                  label={t("donatore.cellulare")}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  slotProps={{
                    input: {
                      readOnly: userCanWriteAndDelete ? false : true,
                    },
                  }}
                />
              </Grid>
              <Grid size={4}>
                <Field
                  component={FormikTextField}
                  name="email"
                  label={t("donatore.email")}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  slotProps={{
                    input: {
                      readOnly: userCanWriteAndDelete ? false : true,
                    },
                  }}
                />
              </Grid>
              <Grid size={4}>
                <Field
                  component={FormikTextField}
                  name="cf"
                  label={t("donatore.cf")}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  slotProps={{
                    input: {
                      readOnly: userCanWriteAndDelete ? false : true,
                    },
                  }}
                />
              </Grid>
              <Grid size={4}>
                <Field
                  component={FormikTextField}
                  name="doc_id"
                  label={t("donatore.doc_id")}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  slotProps={{
                    input: {
                      readOnly: userCanWriteAndDelete ? false : true,
                    },
                  }}
                />
              </Grid>
              <Grid size={12}>
                <Field
                  component={FormikTextField}
                  name="note"
                  label={t("donatore.note")}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  multiline
                  minRows={6}
                  slotProps={{
                    input: {
                      readOnly: userCanWriteAndDelete ? false : true,
                    },
                  }}
                />
              </Grid>
            </Grid>

            <Button ref={ref} type="submit" color="primary" sx={{ display: "none" }}></Button>
          </form>
        )
      }}
    </Formik>
  )
}
